import React from "react";
// MUI
import { Grid2 } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// Styling
import styles from "./SshAccessOption.module.scss";
// Local imports
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import {
  EBS_SSH,
  generateSshPassword,
} from "../../../../../../Utils/roconConstants";

/**
 * Create-site SSH & SFTP password for EBS (v2) sites. Every v2 site gets both (ebs-Buildsite
 * ENABLE_SSH / ENABLE_SFTP, one password); the owner types it here (or asks for a generated
 * one), and this is the one place it can be set. It is never stored by the UI.
 */
export default function SshAccessOption({
  password,
  errorMessage,
  onPasswordChange,
}) {
  return (
    <Grid2 className={styles.sshContainer}>
      <Grid2 className={styles.optionRow}>
        <Grid2>
          <Grid2 className={styles.optionTitle}>{EBS_SSH.CREATE_TITLE}</Grid2>
          <Grid2 className={styles.optionSubtitle}>
            {EBS_SSH.SECTION_SUBTITLE}
          </Grid2>
        </Grid2>
      </Grid2>

      <Grid2 className={styles.passwordBox}>
        <CustomInput
          title={EBS_SSH.PASSWORD_TITLE}
          placeholder={EBS_SSH.PASSWORD_PLACEHOLDER}
          value={password}
          setValue={(value) => onPasswordChange(value)}
          autocomplete={"off"}
          password={true}
          passwordview={true}
          copyable={true}
          error={Boolean(errorMessage)}
          errorMessage={errorMessage}
        />
        <Grid2
          className={styles.generate}
          role="button"
          onClick={() => onPasswordChange(generateSshPassword())}
        >
          {EBS_SSH.GENERATE}
        </Grid2>
        <Grid2 className={styles.note}>
          <InfoOutlinedIcon className={styles.noteIcon} />
          <span>{EBS_SSH.SHOW_ONCE_NOTE}</span>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
